import { render, staticRenderFns } from "./ObjectURL.vue?vue&type=template&id=5977a51e&"
import script from "./ObjectURL.vue?vue&type=script&lang=js&"
export * from "./ObjectURL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports